import React, { createContext, useContext, useEffect, useState } from 'react';

const ShopFavoritesContext = createContext(null);

export const useShopFavorites = () => {
  const context = useContext(ShopFavoritesContext);
  if (!context) {
    throw new Error('useShopFavorites must be used within a ShopFavoritesProvider');
  }
  return context;
};

const readStoredFavorites = (orgId) => {
  try {
    const raw = localStorage.getItem(`zoea-shop-favorites-${orgId}`);
    return raw ? JSON.parse(raw) : [];
  } catch (error) {
    return [];
  }
};

export const ShopFavoritesProvider = ({ orgId, children }) => {
  const [favoriteIds, setFavoriteIds] = useState(() => readStoredFavorites(orgId));

  useEffect(() => {
    localStorage.setItem(`zoea-shop-favorites-${orgId}`, JSON.stringify(favoriteIds));
  }, [favoriteIds, orgId]);

  const toggleFavorite = (productId) => {
    setFavoriteIds((prev) => (prev.includes(productId) ? prev.filter((id) => id !== productId) : [...prev, productId]));
  };

  const isFavorite = (productId) => favoriteIds.includes(productId);

  const value = { favoriteIds, toggleFavorite, isFavorite };

  return <ShopFavoritesContext.Provider value={value}>{children}</ShopFavoritesContext.Provider>;
};

export default ShopFavoritesContext;
